








import { Vue, Component } from 'vue-property-decorator'
import * as _ from 'underscore'
import { Toast } from 'mint-ui'
import config from '../../config'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import { env } from '@ivy/fts/envInfo/envInfo'
@Component({})
export default class DemoTest extends Vue {
  async mounted() {
    await env.init(() => this.$Toast(`分享成功`))
  }
  async sharePage() {
    await env.share({
      title: '测试分享',
      content: '我是分享的内容柔柔弱弱若若若若若若若',
      pic_url:
        'http://service.ivydad.com/wechat/images/911c43b3-df10-e3d6-77fe-11a6ceeef1e0.jpeg',
      url: 'http://m.ivydad.com.cn/center',
    })
  }
  async shareImage() {
    this.$Toast(`${JSON.stringify(env.shareImage)}`)
    await env.shareImage(
      'http://service.ivydad.com/wechat/images/b6a5777d-4ef2-9446-a973-c83ff76ecaf1.jpg'
    )
  }
  async jumpMiniProgram() {
    await env.toWXMiniProgram({
      username: 'gh_5a90479f1dba',
      path: 'pages/dubbingDetail/main?id=246&memId=61272&new=1',
      extraData: '',
      miniQr:
        'http://service.ivydad.com/wechat/images/911c43b3-df10-e3d6-77fe-11a6ceeef1e0.jpeg',
    })
  }
  setT() {
    env.setTitle('测试设置标题')
  }
}
